import { motion } from "framer-motion";
import truckImage from "./assets/core.png";
import checkIcon from "./assets/check-blue.svg";
import "./Time.css";

const TimeCore = () => {
  const featuress = [
    {
      id: "clock-in-out",
      title: "Clock In/Out",
      desc: "Enable employees to record work hours effortlessly using time clocks, mobile apps, or biometric systems.",
    },
    {
      id: "automated-tracking",
      title: "Automated Tracking",
      desc: "Automatically calculate regular hours, overtime, and breaks from clock punches and schedules to eliminate manual errors.",
    },
    {
      id: "shift-scheduling",
      title: "Shift Scheduling",
      desc: "Easily create, assign, and adjust employee schedules to ensure optimal coverage and minimize conflicts.",
    },
    {
      id: "leave-management",
      title: "Leave Management",
      desc: "Manage PTO, sick leave, and vacation requests with automated approvals and real-time visibility.",
    },
  ];

  return (
    <section className="timecore-section w-full bg-[white] py-20 px-6 md:px-16 font-['Epilogue'] overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        <motion.div
          className="relative w-full flex justify-center"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <img
            src={truckImage}
            alt="Time & Attendance"
            className="w-full max-w-[650px] rounded-3xl"
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <h2 className="timecore-title text-gray-900 mb-6">
            Core Functions of a Time & Attendance System
          </h2>
          <p className="timecore-description text-gray-600 mb-6">
            A modern Time & Attendance system automates tracking, calculation,
            and management of workforce hours. It delivers accurate data for
            payroll, operations, and compliance needs.
          </p>
          <div className="my-6 border-t border-gray-200"></div>
          <div className="space-y-5">
            {featuress.map((f, i) => (
              <motion.div
                key={f.id}
                className="flex items-start space-x-3"
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.8 + i * 0.2, duration: 0.6 }}
                viewport={{ once: true }}
              >
                <img src={checkIcon} alt="check" className="w-5 h-5 mt-1" />
                <p className="timecore-feature text-gray-700">
                  <span className="timecore-feature-title">
                    {f.title}
                  </span>{" "}
                  – {f.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TimeCore;
